import React, { useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { multiBookingWarning } from './helper';

import { DialogBox, useDialog, mapDialogMessage } from '../../../comps/dialog';
import { receiveCrosstabWarning, closeCrosstabWarning } from '../../../helpers/crosstab-warning';

// import { channel, sendCrosstabWarning} from './channel';
const instanceId = Math.random().toString(36).substring(2, 15);

function CrosstabWarning({location}: { location: {pathname: string} }) {

  const dialog = useDialog("Multiple Booking", "You have an active booking in another tab or window");

  useEffect(() => {

    receiveCrosstabWarning((data, myBooking) => {
      if(data.type !== 'mmb' || !data.pnr || !myBooking || data.pnr !== myBooking) return;

      const message = multiBookingWarning.replace('{0}', data.pnr);
      dialog.show(message)
      .then(() => {})
      .catch(() => {});
    });

    return () => {
      closeCrosstabWarning(); 
    }
  }, []);


  return (
    <DialogBox open={dialog.open} title={dialog.title} closeButtonText={'Confirm'} onClose={dialog.close} hideCancelButton={true}>
      { mapDialogMessage(dialog.message) }
    </DialogBox>
  )
}

export default withRouter(CrosstabWarning);